<template>
  <a-modal
    class="modal-content"
    :title="`${modelType === 'edit' ? '编辑' : modelType === 'view' ? '查看' : '添加'}${title}`"
    :width="900"
    :visible="visible"
    ok-text="保存"
    v-bind="extraProps"
    destroyOnClose
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item label="辅导时间" prop="tutoringTime">
          <a-date-picker
            v-model="form.tutoringTime"
            placeholder="请选择日期"
            :disabled="isView"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="辅导类型" prop="tutoringType">
          <j-dict-select-tag
            v-model="form.tutoringType"
            placeholder="请选择辅导类型"
            :extraOptions="menuMaps.tutoringType"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item label="辅导方法" prop="tutoringMethod">
          <j-dict-select-tag
            v-model="form.tutoringMethod"
            placeholder="请选择辅导方法"
            dictCode="tutoring_method"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item label="问题原因" prop="reason">
          <j-dict-select-tag
            v-model="form.reason"
            placeholder="请选择问题原因"
            mode="multiple"
            :extraOptions="menuMaps.psychologyIssues"
            :disabled="isView"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="干预措施" prop="interventionId">
          <j-dict-select-tag
            v-model="form.interventionId"
            mode="multiple"
            placeholder="请选择干预措施"
            :extraOptions="menuMaps.intervention"
            :disabled="isView"
          />
        </a-form-model-item> -->
        <a-form-model-item label="下一步措施" prop="nextIntervention">
          <j-dict-select-tag
            v-model="form.nextIntervention"
            mode="multiple"
            placeholder="请选择下一步措施"
            :extraOptions="menuMaps.nextIntervention"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item label="效果反馈" prop="effectFeedback">
          <j-dict-select-tag
            v-model="form.effectFeedback"
            placeholder="请选择效果反馈"
            :extraOptions="menuMaps.effectFeedback"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item label="危机等级" prop="crisisLevel">
          <j-dict-select-tag
            v-model="form.crisisLevel"
            placeholder="请选择危机等级"
            :extraOptions="menuMaps.careList"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item
          label="以上信息是否反馈校领导"
          prop="feedbackFlag"
          :labelCol="{ span: 5 }"
          :wrapperCol="{ span: 18 }"
        >
          <a-radio-group
            v-model="form.feedbackFlag"
            :disabled="isView"
            @change="handleFeedbackChange"
          >
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.feedbackFlag === 1" label="请选择校领导" prop="leaderId">
          <j-dict-select-tag
            filterable
            v-model="form.leaderId"
            placeholder="请选择校领导"
            mode="multiple"
            :extraOptions="menuMaps.schoolLeaders"
            :disabled="isView"
          />
        </a-form-model-item>
        <a-form-model-item label="辅导记录表">
          <a-upload
            v-if="!isView"
            name="file"
            :multiple="true"
            :headers="tokenHeader"
            :action="importExcelUrl"
            :file-list="defaultFileList"
            @change="uploadFile"
            @preview="handlePreview"
          >
            <a-button v-if="defaultFileList.length < 3" icon="import">上传文件</a-button>
          </a-upload>
          <div v-else-if="isView && form.tutorRecordUrl" class="view-file-list">
            <span
              v-for="(url, index) in (form.tutorRecordUrl || '').split(',').filter(Boolean)"
              :key="index"
              class="view-file-item"
              @click="handleFilePreview(url)"
            >
              <a-icon type="paper-clip" />
              附件{{ index + 1 }}
            </span>
          </div>
          <span v-else>无</span>
        </a-form-model-item>
        <a-form-model-item label="具体情况说明">
          <a-textarea
            v-model="form.specificInstructions"
            placeholder="请输入具体情况说明"
            :auto-size="{ minRows: 4, maxRows: 8 }"
            :disabled="isView"
            :maxlength="200"
          />
        </a-form-model-item>
        <!-- <WangEditor
            v-model="form.comment"
            :editorStyle="{ minHeight: '200px' }"
            :readOnly="modelType === 'view'"
            style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"
          /> -->
        <!-- </a-form-model-item> -->
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import WangEditor from '@/components/WangEditor'
import JMultiSelectTag from '@comp/dict/JMultiSelectTag.vue'
import { postAction, getAction, getFileAccessHttpUrl } from '@api/manage'
import moment from 'moment'
import {mapGetters} from 'vuex'
// getStoreFileUrl

export default {
  name: 'addLedgerModal',
  mixins: [JeecgListMixin],
  
  components: {
    WangEditor,
    JMultiSelectTag,
  },
  props: {
    title: {
      type: String,
      default: '学生辅导记录',
    },
  },
  computed: {
    // 是否为查看模式（禁用所有输入项）
    isView() {
      return this.modelType === 'view'
    },
    ...mapGetters(['identityId']),
  },
  data() {
    return {
      visible: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      itemLabelCol: { span: 8 },
      itemWrapperCol: { span: 15 },
      form: {},
      rules: {
        tutoringTime: [{ required: true, message: '请选择辅导时间', trigger: 'change' }],
        tutoringMethod: [{ required: true, message: '请选择辅导方法', trigger: 'change' }],
        tutoringType: [{ required: true, message: '请选择辅导类型', trigger: 'change' }],
        reason: [{ required: true, message: '请选择问题原因', trigger: 'change' }],
        // interventionId: [{ required: true, message: '请选择干预措施', trigger: 'change' }],
        nextIntervention: [{ required: true, message: '请选择干预措施', trigger: 'change' }],
        effectFeedback: [{ required: true, message: '请选择效果反馈', trigger: 'change' }],
        crisisLevel: [{ required: true, message: '请选择危机等级', trigger: 'change' }],
        feedbackFlag: [{ required: true, message: '请选择是否反馈', trigger: 'change' }],
        leaderId: [
          {
            validator: (rule, value, callback) => {
              if (
                this.form.feedbackFlag === 1 &&
                (!value || (Array.isArray(value) && value.length === 0))
              ) {
                callback(new Error('请选择校领导'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
      },
      currRecord: {},
      currEvalInfo: {},
      richText: '',
      importExcelUrl: window._CONFIG['domianURL'] + '/sys/common/upload?biz=emotionComments',
      modelType: '',
      extraProps: {},
      defaultFileList: [],
      disableMixinCreated: true,
      menuMaps: {
        crisisLevel: [],
        psychologyIssues: [],
        tutoringType: [],
        schoolLeaders: [],
        nextIntervention: [],
        effectFeedback: [],
      },
    }
  },
  created() {
    this.getMenuMaps()
    this.getSchoolLeaders()
  },
  methods: {
    async getMenuMaps() {
      const res = await getAction('/schoolCounselingRecord/queryCounselingRecordParams', {})
      const result = res.result
      if (result) {
        for (let key in result) {
          // 直接使用接口返回的变量名
          if (result[key]) {
            const list = result[key].map((item) => {
              return {
                ...item,
                text: item.itemText,
                title: item.itemText,
                value: item.itemValue,
              }
            })
            this.$set(this.menuMaps, key, list)
          }
        }
      }
    },
    async getSchoolLeaders() {
      try {
        const res = await getAction('/schoolCounselingRecord/querySchoolLeader', {})
        const result = res.result
        const list = result.map((item) => {
          return {
            ...item,
            text: item.realname,
            title: item.realname,
            value: item.id,
          }
        })
        this.$set(this.menuMaps, 'schoolLeaders', list)
      } catch (e) {
        console.error('获取校领导列表失败', e)
      }
    },
    showModal(record, type) {
      console.log('record记录', record, type)
      this.currRecord = record
      this.visible = true
      // if (type === 'edit' || type === 'view') {
      //   this.form = {
      //     id: record.id,
      //     // ementId: record.ementId,
      //     tutoringTime: record.tutoringTime,
      //     tutoringType: record.tutoringType,
      //     // tutoringMethod: record.tutoringMethod,
      //     reason: record.reason ? record.reason.split(',') : [],
      //     interventionId: record.interventionId ? record.interventionId.split(',') : [],
      //     effectFeedback: record.effectFeedback || undefined,
      //     crisisLevel: record.crisisLevel,
      //     feedbackFlag: record.feedbackFlag || 0,
      //     leaderId: record.leaderId ? record.leaderId.split(',') : [],
      //     specificInstructions: record.specificInstructions,
      //     tutorRecordUrl: record.tutorRecordUrl,
      //   }
      //   this.extraProps = type === 'view' ? { footer: null } : {}
      //   this.modelType = type
      //   this.defaultFileList = record.tutorRecordUrl
      //     ? record.tutorRecordUrl
      //         .split(',')
      //         .filter(Boolean)
      //         .map((item, index) => ({
      //           uid: -index - 1,
      //           name: '附件' + (index + 1),
      //           status: 'done',
      //           url: item,
      //         }))
      //     : []
      // } else if (type === 'append') {
      //   this.modelType = type
      //   this.defaultFileList = []
      // } else {
      //   this.form = {
      //     feedbackFlag: 0,
      //   }
      //   this.defaultFileList = []
      // }
      // this.visible = true
    },
    // 处理反馈校领导变化
    handleFeedbackChange() {
      if (this.form.feedbackFlag == 0) {
        this.form.leaderId = []
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate('leaderId')
        })
      }
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.extraProps = {}
      this.modelType = ''
      this.defaultFileList = []
    },
    async handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const res = await postAction('/aigoes/studentSign/edit', {
          commentsId: this.currRecord.id,
          bootRecord: this.form.specificInstructions || '',
          id: this.currRecord.id,
          currentState: 2,
        })
        if (res.success) {
          this.$message.success(res.message)
          const commonData = {
            // 辅导时间
            careTime: moment(this.form.tutoringTime).format('YYYY-MM-DD 00:00:00'),
            // 具体情况说明
            remark: this.form.specificInstructions,
            // 辅导类型
            tutoringType: this.form.tutoringType,
            // 辅导方法
            tutoringMethod: this.form.tutoringMethod || '',
            // 问题原因
            psychologyIssues: Array.isArray(this.form.reason) ? this.form.reason.join(',') : this.form.reason,
            // 下一步措施
            nextIntervention: Array.isArray(this.form.nextIntervention)
            ? this.form.nextIntervention.join(',')
            : this.form.nextIntervention,
            // 效果反馈
            effectFeedback: this.form.effectFeedback,
            // 危机等级
            crisisLevel: this.form.crisisLevel,
            // 是否反馈校领导
            feedbackFlag: this.form.feedbackFlag,
            // 校领导
            leaderId: Array.isArray(this.form.leaderId)
              ? this.form.leaderId.join(',')
              : this.form.leaderId,
            title: this.identityId,
            attachUrls:this.defaultFileList
              .filter((item) => item.status === 'done')
              .map((item) => item.url || item.response?.message || item.response?.result)
              .filter(Boolean)
              .join(','),
          };
          await postAction('/aigoes/schoolWarnRecord/warnProcess', {
            id: this.currRecord.id,
            warnStatus: 5,
            comment: '已辅导完成',
            ...commonData
            
          })
          this.$emit('refreshData')
        } else {
          this.$message.error(res?.message || '操作失败')
        }
        this.hideModal()
      })
    },
    handleCancel() {
      this.hideModal()
    },
    uploadFile(info) {
      console.log('文件信息：', info)
      let fileList = [...info.fileList]
      // 限制最多 3 张
      if (fileList.length > 3) {
        this.$message.warning('最多只能上传 3 张图片/文件')
        fileList = fileList.slice(0, 3)
      }
      this.defaultFileList = fileList

      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.$message.success('上传成功')
          // 这里的 url 逻辑需要根据后端返回结构微调，通常是 info.file.response.message 或 result
        } else {
          this.$message.error(info.file.response.message || '上传失败')
          this.defaultFileList = this.defaultFileList.filter((item) => item.uid !== info.file.uid)
        }
      } else if (info.file.status === 'error') {
        this.$message.error('上传失败')
      }
    },
    // 预览/点击附件
    handlePreview(file) {
      const url = file.url || file.response?.message || file.response?.result
      if (url) {
        const fullUrl = getFileAccessHttpUrl(url)
        window.open(fullUrl)
      }
    },
    handleFilePreview(url) {
      if (url) {
        const fullUrl = getFileAccessHttpUrl(url)
        window.open(fullUrl)
      }
    },
    // 下载附件
    downloadAttachment() {
      const fileArr = (this.form.tutorRecordUrl || '').split(',').filter(Boolean)
      if (!fileArr.length) return
      fileArr.forEach((item) => {
        const fullUrl = getFileAccessHttpUrl(item)
        window.open(fullUrl)
      })
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-form-item {
    margin-bottom: 12px;
  }
}

.view-file-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 10px;
}

.view-file-item {
  color: #1890ff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  i {
    margin-right: 4px;
  }
}
</style>
